import React, { FC, useEffect } from 'react';
import { Dropdown } from '@silverfort/sf-components';

interface Props {
    selectedSettings: string | string[] | undefined;
    setSelectedSettings: (value?: string | string[]) => void;
    options: { value: string; title: string }[];
    addNewItemHandler?: (value?: string) => void;
    multiple?: boolean;
}

const SelectSettingsComponent: FC<Props> = ({
    selectedSettings,
    setSelectedSettings,
    options,
    addNewItemHandler,
    multiple
}) => {
    useEffect(() => {
        if (options?.length > 0 && !selectedSettings?.length) {
            setSelectedSettings(multiple ? [options[0].value] : options[0].value);
        }
    }, []);

    return (
        <Dropdown
            variant="trigger"
            items={options}
            selectedItems={selectedSettings ?? 'Loading...'}
            onChange={(value) => setSelectedSettings(value)}
            fullMenuWidth
            className="w-full"
            multiple={multiple}
            searchable
            addNewItemHandler={addNewItemHandler}
        />
    );
};

export default SelectSettingsComponent;
